(function (w) {
	'use strict';

	/**
	 * @ngdoc type
	 * @name mx.SolutionBuilderAgent.LocalizableResource
	 * @module mx.SolutionBuilderAgent
	 *
	 * @description
	 * An implementation of localizable resource
	 *
	 * @property {boolean} global - Gets the localizable resource type (either global or context specific).
	 * @property {string} name - Gets the localizable resource name.
	 * @property {string} description - Gets the localizable resource description.
	 * @property {string} values - Gets the localizable resource values object.
	 */
	function LocalizableResource(options) {
		options = options || {};
		var that = this;

		Object.defineProperty(that, '__type', {
			writable: false,
			enumerable: true,
			value: mx.SolutionBuilderAgent.TemplatePropertyValueTypes.local.id,
		});

		Object.defineProperty(that, 'datatype', {
			writable: false,
			enumerable: true,
			value: options.datatype || 'local',
		});

		var resKey = options.resourceKey || options.ResourceKey;
		var id = options.Id || options.Key;

		Object.defineProperty(that, 'global', {
			writable: false,
			enumerable: true,
			value: options.global,
		});
		Object.defineProperty(that, 'id', {
			writable: true,
			enumerable: true,
			value: id,
		});
		Object.defineProperty(that, 'Key', {
			writable: true,
			enumerable: true,
			value: id,
		});
		Object.defineProperty(that, 'ResourceKey', {
			writable: true,
			enumerable: true,
			value: resKey,
		});
		Object.defineProperty(that, 'Description', {
			writable: true,
			enumerable: true,
			value: options.Description || '',
		});
		Object.defineProperty(that, 'Value', {
			writable: true,
			enumerable: true,
			value: options.Value || '',
		});
		Object.defineProperty(that, 'lower', {
			enumerable: false,
			get: function () {
				return this.Value.toLowerCase();
			},
		});
		Object.defineProperty(that, 'editMode', {
			writable: true,
			enumerable: false,
			value: false,
		});
		Object.defineProperty(that, 'notUsed', {
			writable: true,
			enumerable: false,
			value: false,
		});
		Object.defineProperty(that, '_descr', {
			writable: true,
			enumerable: false,
			value: false,
		});
		Object.defineProperty(that, '_name', {
			writable: true,
			enumerable: false,
			value: false,
		});
		Object.defineProperty(that, '__hover', {
			writable: true,
			enumerable: false,
			value: false,
		});

		Object.defineProperty(that, 'name', {
			writable: true,
			enumerable: false,
			value: that.Value,
		});

		Object.defineProperty(that, 'Translations', {
			writable: true,
			enumerable: true,
			value: options.Translations,
		});
	}

	LocalizableResource.prototype.toString = function () {
		return '[' + this.name + '::' + (this.global ? 'GLOBAL ' : '') + 'RES]';
	};
	LocalizableResource.prototype.toJSON = function () {
		var res = {
			__type: mx.SolutionBuilderAgent.TemplatePropertyValueTypes.local.id,
			datatype: this.datatype,
		};

		if (this.datatype === 'datamodel') {
			res.ResourceKey = this.ResourceKey;
		} else {
			res.Id = this.Key || this.Id;
		}

		return res;
	};
	LocalizableResource.prototype.format = function (lcid) {
		var localized;
		if (this.Translations) {
			localized = _.find(this.Translations, { lcid: lcid }) || _.find(this.Translations, { Lcid: lcid });
		}

		var localizedValue = (localized && (localized.value || localized.Value)) || this.Value;
		return '[' + localizedValue + '::' + (this.global ? 'GLOBAL ' : '') + 'RES]';
	};

	w.mx = w.mx || {};
	w.mx.SolutionBuilderAgent = w.mx.SolutionBuilderAgent || {};
	w.mx.SolutionBuilderAgent.LocalizableResource = LocalizableResource;
})(window);
